import React from 'react';
import SEO from "../components/seo";
import Layout from "../components/layout";
import { Button, Form, FormGroup, Label, Input } from 'reactstrap';


class  Consultation extends React.Component {

  render() {
    return(
      <Layout>
        <SEO title="Contact" keywords={[`Garden`, `Vertical Garden`, `Office garden`]} />

        <section className="section pt-3">
          <div className="container">

            <div className="text-center mb-5">
                <h2 className="heading heading--lg text-uppercase">
                  book a consultation
                </h2>
            </div>

            <div className="row">
              <div className="col-md-8 offset-md-2">
                <div className="row">

                    <Form className='form d-md-flex flex-md-wrap' data-netlify-honeypot="bot-field" data-netlify="true" action="/" name="consultation" method="POST">
                    <input type="hidden" name="form-name" value="consultation" />  
                        <div className="col-md-6">
                            <FormGroup>
                                <Label className="form__label" for="firstName">First Name</Label>
                                <Input className="form__input" type="text" name="firstName" id="firstName" />
                            </FormGroup>
                        </div>
                        <div className="col-md-6">
                
                            <FormGroup>
                                <Label className="form__label" for="lastName">Last Name</Label>
                                <Input className="form__input" type="text" name="lastName" id="lastName" />
                            </FormGroup>
                        </div>
                        <div className="col-md-12">
                            <FormGroup>
                                <Label className="form__label" for="email">Email</Label>
                                <Input className="form__input" type="email" name="email" id="email" />
                            </FormGroup>
                        </div>
                        <div className="col-md-12">
                
                            <FormGroup>
                                <Label className="form__label" for="phone">Phone</Label>
                                <Input className="form__input" type="text" name="phone" id="phone" />
                            </FormGroup>
                        </div>
                        <div className="col-md-12">
                
                            <FormGroup>
                                <Label className="form__label" for="street-address">Address</Label>
                                <textarea className="form__input" type="text" name="street-address" id="street-address" > </textarea>
                            </FormGroup>
                        </div>
                        <div className="col-md-12">
                            <Button className="link link--filled"  type="submit">Submit</Button>
                        </div>
                    </Form>
                </div>
              </div>
            </div>
          </div>
        
        </section>
   
      </Layout>
    );
  }  
}

export default Consultation;